import { baseApi } from "../baseApi";

export const StateApi = baseApi.injectEndpoints({

  endpoints: (builder) => ({
    // CREATE ADMIN - JSON format me bhej raha hai
    createAdmin: builder.mutation({
      query: (formData) => ({
        url: "/create-admin",
        method: "POST",
        headers: {
          'Content-Type': 'application/json', // JSON header
        },
        body: JSON.stringify(formData), // JSON stringify kar rahe hain
      }),
      invalidatesTags: ["Admin"],
    }),

    // GET ALL
    getState: builder.query({
      query: ({ page = 1, limit = 10, search = "", status = "", } = {}) =>
        `/state-list?page=${page}&limit=${limit}&search=${search}&status=${status}`,

      providesTags: ["State"],
    }),
    // UPDATE
    updateState: builder.mutation({
      query: (data) => ({
        url: `/state-update`,
        method: "POST",
        body: data,
      }),

      invalidatesTags: ["State"],
    }),
    changeStatusState: builder.mutation({
      query: (id) => ({
        url: `/state-status/${id}`,
        method: "GET",
      }),

      invalidatesTags: ["State"],
    }),

    // DELETE
    deleteState: builder.mutation({
      query: (data) => ({
        url: `/state-delete`,
        method: "DELETE",
        body: data
      }),

      invalidatesTags: ["State"],
    }),

  }),

});

export const {
  useCreateStateMutation,
  useGetStateQuery,
  useUpdateStateMutation,
  useDeleteStateMutation,
  useChangeStatusStateMutation

} = StateApi;